/*
包含一些常量值的模块
 */

export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN;
export const WEB_DOMAIN = process.env.REACT_APP_WEB_DOMAIN;
export const WEB_KEY = process.env.REACT_APP_WEB_KEY;